module.exports = __webpack_public_path__ + "static/media/wood.413364c9.jpg";